import React, { useState, useEffect ,useRef} from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Editor } from '@tinymce/tinymce-react';
import SidebarLayout from 'components/Layout/Layout';
import { API_URL } from 'env';
import { Modal } from "antd";

const EditProduct: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [imageBase64, setImageBase64] = useState<string>('');
  const editorRef = useRef<any>(null);

  const [form, setForm] = useState({
    title: '',
    type: '',
    number: '',
    description: '',
    position: '',
    locale: 'vi',
  });
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(true);
  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
      const value = e.target.value;
      if (editorRef.current && value) {
        editorRef.current.insertContent(value); 
      }
      e.target.value = "";
  };
  const handleSubmit = () => {
        if (editorRef.current) {
            console.log(editorRef.current.getContent()); // lấy content
        }
    };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoadingData(true);
        const response = await fetch(`${API_URL}api/v1/be/section_indexes/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        const json = await response.json();
        if (json.status) {
           setForm({
            ...json.data,
            numbers: json.data.numbers?.life_path || ''
          });
          setImageBase64(json.data.image_url || '');
        } else {
          Modal.error({
            title: "Lỗi",
            content: "Lấy dữ liệu thất bại",
            onOk: () => navigate("/product"),
          });
        }
      } catch (error: any) {
        Modal.error({
          title: "Lỗi",
          content: "Lỗi khi tải dữ liệu: " + error.message,
          onOk: () => navigate("/product"),
        });
      } finally {
        setLoadingData(false);
      }
    };
    fetchData();
  }, [id, navigate]);

  const handleSave = async () => {
    if (!form.title.trim()) {
      Modal.warning({ title: "Cảnh báo", content: "Vui lòng nhập tiêu đề" });
      return;
    }
    if (!form.type.trim()) {
      Modal.warning({ title: "Cảnh báo", content: "Vui lòng nhập subtitle" });
      return;
    }

    try {
      setLoading(true);
      const payload = {
      ...form,
      image: imageBase64,  
      
  };
      const response = await fetch(`${API_URL}api/v1/be/section_indexes/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        body:  JSON.stringify(payload),
      });

      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

      const json = await response.json();

      if (json.status) {
        Modal.success({
          title: "Thành công",
          content: "Cập nhật thành công",
          onOk: () => navigate("/product-section"),
        });
      } else {
        Modal.error({
          title: "Lỗi",
          content: "Có lỗi: " + (json.message || "Unknown error"),
        });
      }
    } catch (error: any) {
      Modal.error({
        title: "Lỗi",
        content: "Lỗi khi cập nhật: " + error.message,
      });
    } finally {
      setLoading(false);
    }
  };

  if (loadingData) return <p>Đang tải dữ liệu...</p>;

  return (
      <SidebarLayout title={<h4 className="text-2xl font-bold !m-0 py-4">Thêm mới Product</h4>}>
            <div className="p-4 bg-white rounded shadow" >
                <h3 className="text-xl font-bold mb-4" style={{ color: '#5e5873' }}>
                    Thông tin chung
                </h3>
                <div className="grid grid-cols-2 gap-4">
                    <div className="mb-4">
                        <label className="block font-semibold mb-1" style={{ color: '#5e5873', marginBottom: '10px' }}>
                            Ngôn ngữ
                        </label>
                        <select
                            value={form.locale}
                            onChange={(e) => setForm({ ...form, locale: e.target.value })}
                            className="w-full border p-2 rounded"
                            style={{ border: '1px solid #ccc' }}
                        >
                            <option value="vi">Vietnam</option>
                            <option value="en">English</option>
                        </select>
                    </div>

                    <div className="mb-4">
                        <label className="block font-semibold mb-1" style={{ color: '#5e5873', marginBottom: '10px' }}>
                            Title
                        </label>
                        <input
                            type="text"
                            value={form.title}
                            onChange={(e) => setForm({ ...form, title: e.target.value })}
                            className="w-full border p-2 rounded"
                            style={{ border: '1px solid #ccc' }}
                        />
                    </div>

                    <div className="mb-4">
                        <label className="block font-semibold mb-1" style={{ color: '#5e5873', marginBottom: '10px' }}>
                            type
                        </label>
                        <input
                            type="text"
                            style={{ border: '1px solid #ccc' }}
                            value={form.type}
                            onChange={(e) => setForm({ ...form, type: e.target.value })}
                            className="w-full border p-2 rounded"
                        />
                    </div>

                    <div className="mb-4">
                        <label
                            className="block font-semibold mb-1"
                            style={{ color: '#5e5873', marginBottom: '10px' }}
                        >
                            Number
                        </label>
                           <input
                                type="text"
                                style={{ border: '1px solid #ccc' }}
                                value={form.number}
                                onChange={(e) => setForm({ ...form, number: e.target.value })}
                                className="w-full border p-2 rounded"
                            />
                    </div>
                    <div className="mb-4">
                        <label className="block font-semibold mb-1" style={{ color: '#5e5873', marginBottom: '10px' }}>
                          hình ảnh
                        </label>
                        <input
                            type="file"
                            className="w-full border p-2 rounded"
                            style={{ border: '1px solid #ccc' }}
                            accept="image/*"
                            onChange={(e) => {
                                const file = e.target.files?.[0];
                                if (file) {
                                    const reader = new FileReader();
                                    reader.onloadend = () => setImageBase64(reader.result as string);
                                    reader.readAsDataURL(file);
                                }
                            }}
                        />
                        {imageBase64 && (
                            <img
                            src={imageBase64}
                            alt="Preview"
                            style={{ marginTop: '10px', width: '100px', height: '100px', objectFit: 'cover', borderRadius: '4px' }}
                            />
                        )}

                    </div>
                    <div className="mb-4">
                        <label className="block font-semibold mb-1" style={{ color: '#5e5873', marginBottom: '10px' }}>
                            position
                        </label>
                        <input
                            type="text"
                            value={form.position}
                            onChange={(e) => setForm({ ...form, position: e.target.value })}
                            className="w-full border p-2 rounded"
                            style={{ border: '1px solid #ccc' }}
                        />
                    </div>
                </div>
                <div className="mb-4">
                    <label className="block font-semibold mb-1" style={{ color: '#5e5873', marginBottom: '10px' }}>
                        Param
                    </label>
                    <select className="w-full border p-2 rounded"
                        style={{ border: '1px solid #ccc',marginBottom: 10, padding: 5  }} onChange={handleSelectChange} >
                        <option value="">-- Chọn dữ liệu --</option>
                        <option value="[name]">[name] Tên khách khách hàng</option>
                        <option value="[birthday]">[birthday] Ngày sinh</option>
                    </select>
                </div>

                <div className="mb-4">
                    <label className="block font-semibold mb-1" style={{ color: '#5e5873', marginBottom: '10px' }}>
                        Nội dung
                    </label>
                    <div className="border rounded" style={{ border: '1px solid #ccc' }}>
                        <Editor
                            apiKey="8idrshqq41s3566uw9r35h7yd71a2lhzpzfkn6pywrmjf26k"
                            value={form.description}
                            onInit={(_, editor) => (editorRef.current = editor)}
                            init={{
                                height: 300,
                                menubar: 'file edit view insert format tools table help',
                                plugins: [
                                'advlist autolink lists link image charmap print preview anchor',
                                'searchreplace visualblocks code fullscreen',
                                'insertdatetime media table paste code help wordcount',
                                ],
                                toolbar:
                                'undo redo | formatselect | bold italic underline strikethrough | ' +
                                'alignleft aligncenter alignright alignjustify | ' +
                                'bullist numlist outdent indent | removeformat | help',
                            }}
                            onEditorChange={(content) => setForm({ ...form, description: content })}
                        />
                    </div>
                </div>


                <div className="flex justify-end gap-2">
                <button
                    onClick={() => navigate('/daily')}
                    className="border px-4 py-2 rounded"
                    disabled={loading}
                >
                    Hủy
                </button>
                <button
                    onClick={handleSave}
                    className="bg-blue-500 text-white px-4 py-2 rounded disabled:opacity-50"
                    disabled={loading}
                >
                    {loading ? 'Đang xử lý...' : 'Thêm'}
                </button>
                </div>
            </div>
        </SidebarLayout>
  );
};

export default EditProduct;
